// fetchNotificationOembedData.js
'use strict';
import fetchOembedData from '../action/fetchOembedData.js';
import getOperationData from '../selector/getOperationData.js';
import getCurrentLanguage from '../resource/getCurrentLanguage.js';
import {
  DETAIL_SELECT_PATH_PREFIX,
  CONTENT_SIZE_SELECT_PATH_PREFIX,
} from '../resource/popupNotificationConstants.js';

/**
 * Fetch notification oembed data
 * @kind action
 * @param {string} {tag} - notification tag.
 * @return {Promise} Action promise.
 */
const fetchNotificationOembedData =
  ({ tag }) =>
  async (dispatch, getState) => {
    const notification = getOperationData(
      getState(),
      DETAIL_SELECT_PATH_PREFIX,
      tag
    );
    const link = notification?.link;
    const position = notification?.position;

    try {
      const width =
        getOperationData(
          getState(),
          [...CONTENT_SIZE_SELECT_PATH_PREFIX, position],
          'width'
        ) || 0;
      const height =
        getOperationData(
          getState(),
          [...CONTENT_SIZE_SELECT_PATH_PREFIX, position],
          'height'
        ) || 0;

      return dispatch(
        fetchOembedData({
          url: link,
          language: getCurrentLanguage(),
          maximumWidth: width,
          maximumHeight: height,
        })
      );
    } catch (error) {
      return dispatch({ type: '' });
    }
  };

export default fetchNotificationOembedData;
